
import Glider from 'glider-js/glider.js'
var commentsGlinder;
var comments = function () {
    
    var getcomments = function() {

        commentsGlinder = new Glider(document.querySelector('.gliderComments'), {
            // Mobile-first defaults
            slidesToShow: 2,
            slidesToScroll: 2,
            scrollLock: true,
            scrollLockDelay:100,
            duration:1,
            draggable: true,
            eventPropagate:false,
            dots: '.dots',
            responsive: [
                {
                    breakpoint: 270,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        itemWidth: 270,
                        duration: 0.25
                    }
                },
                {
                    breakpoint: 775,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        itemWidth: 270,
                        duration: 0.25
                    }
                },
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        itemWidth: 270,
                        duration: 0.25
                    }
                },{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        itemWidth: 270,
                        duration: 0.25
                    }
                }
            ]
        });

        
        

    }
    return {
        init: function() {
            getcomments();
        }
    };
}();
    
$(function () {
    comments.init();
});
